import axios, {parseResponseData} from '@/axiosInstance'
import {TeamMember, TeamGroup} from '@/features/treatment-requests/teams/types'
import {PaginationParams, PaginationResponse, ResponseType} from '@/types'
import {captureException} from '@sentry/react'
import {z} from 'zod'

// store team
export const HttpStoreTeamOptions = z.object({
    urlParams: z.object({
        treatmentRequestId: z.string().min(1)
    }),
    payload: z.object({
        projectId: z.string().optional(),
        isAReserve: z.boolean(),
        teams: z.array(
            z.object({
                group: TeamGroup,
                users: z.array(z.string())
            })
        )
    })
})
export type HttpStoreTeamOptions = z.infer<typeof HttpStoreTeamOptions>

export const httpStoreTeam = async ({urlParams, payload}: HttpStoreTeamOptions) => {
    const response = await axios.post(`treatment-requests/${urlParams.treatmentRequestId}/teams`, payload)
    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: z.array(TeamMember)
    })
}

// get teams by treatment request
export type HttpGetTeamMembersOptions = {
    urlParams: {
        treatmentRequestId: string
    }
    params: PaginationParams & {
        search?: string
        projectId?: string
        responseType: ResponseType
    }
}

const HttpGetTeamMembersResponse = z.object({
    data: z.array(TeamMember),
    meta: PaginationResponse
})
export type HttpGetTeamMembersResponse = z.infer<typeof HttpGetTeamMembersResponse>

export const httpGetTeamMembers = async ({urlParams, params}: HttpGetTeamMembersOptions) => {
    const response = await axios.get(`treatment-requests/${urlParams.treatmentRequestId}/teams`, {params})
    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: HttpGetTeamMembersResponse
    })
}
